var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("Shows 10 latest products with the title \"Nyheter "+_vm._s(new Date().getFullYear())+"\" (year is dynamic).")])
}
var staticRenderFns = []

export { render, staticRenderFns }